import { Either, left, right } from "fp-ts/lib/Either";
import RestApi from "../../../settings/RestApi";

const restApi = new RestApi();

export const requestCarPickupApiImpl = async (serviceId: string): Promise<Either<string, void>> => {
    try {
        await restApi.post(`/qrcodes/request-deliver/${serviceId}`, {});
        //save id as requested
        localStorage.setItem(`requestedServiceId-${serviceId}`, serviceId);
        return right(undefined);
    } catch (error) {
        return left(error instanceof Error ? error.message : 'Error al solicitar entrega del vehículo');
    }
};
